/**
 * Create a discount-type promotion: name, imageUrl, rewards only (no conditions).
 * @param {Function} requestWithMeta - useHttp().requestWithMeta
 * @param {{ name: string, imageUrl: string, rewards: Array<{ productId: number, discount: number }> }} payload
 * @returns {Promise<{ ok: boolean, data?: any, status?: number }>}
 */
export async function createDiscountPromotion(requestWithMeta, payload) {
  const { name, imageUrl, rewards } = payload;
  const body = {
    name: name?.trim() ?? '',
    imageUrl: imageUrl?.trim() || null,
    conditions: [],
    rewards: rewards.filter((r) => r.productId != null && Number(r.discount) > 0).map((r) => ({
      productId: r.productId,
      discount: Number(r.discount)
    }))
  };
  const res = await requestWithMeta('/operator/promotions', 'POST', body);
  return { ok: res?.ok ?? false, data: res?.data, status: res?.status };
}
